<tds-popover-canvas id="my-popover-canvas" placement="right" [selector]="'#'+id" class="tds-u-p2">
  
  <p class="tds-detail-05 tds-u-m0 tooltip-paragraph tooltip-with-image">

    @if (profile?.tableStatus == 'BLOCKED') {
      <span class="tooltip-text">
      <h1 style="font-size: 10px !important;">Bloqueada</h1>
      </span> 
    }

    @if(profile?.pic){
      <img [src]="'data:image/png;base64,' + profile?.pic" alt="Imagem" class="tooltip-centered-image" style="width: 120px; height: 120px; text-align: center; border-radius: 7px;">
    }

    <span class="tooltip-text">
      <h1 style="font-size: 10px !important;">{{profile?.empName}}</h1>
      <h1 style="font-size: 10px !important;">{{profile?.username}}</h1>
      <h1 style="font-size: 10px !important;">{{profile?.area}}</h1>
    </span>   
    
    
  
    @if(profile?.email){
      <tds-link class="priority-link">
        <a target="_blank" rel="noopener noreferrer" href="https://teams.microsoft.com/l/chat/0/0?users={{profile?.email}}">Teams</a>
      </tds-link>
    }
    
  </p>    
</tds-popover-canvas>


<!-- 
Can't be used at same time actually

<tds-popover-menu
  id="my-popover-menu"
  placement="left"
  animation="fade"
  [selector]="'#'+id"
>
<tds-popover-menu-item>
  <a href="#">Action</a>
</tds-popover-menu-item>
<tds-divider></tds-divider>
<tds-popover-menu-item>
  <a href="#">Action</a>
</tds-popover-menu-item>
<tds-popover-menu-item>
  <a href="#">Action</a>
</tds-popover-menu-item>
<tds-popover-menu-item disabled>
  <button>Disabled action</button>
</tds-popover-menu-item>
<tds-divider></tds-divider>
<tds-popover-menu-item>
  <a href="#">Action</a>
</tds-popover-menu-item>
<tds-divider></tds-divider>
<tds-popover-menu-item>
  <a href="#">Action</a>
</tds-popover-menu-item>
<tds-popover-menu-item>
  <button id="action-button">Close</button>
</tds-popover-menu-item>
</tds-popover-menu>  

-->
